import { put, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import request from 'utils/request';
import urls from 'utils/config';
import { addInstitutionSuccess, addInstitutionFailed, addInstitutionAliasSuccess } from '../actions';
import { IstitutionActionTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* saveInstitution({ data }) {
  const { formData, updateAlias } = data;

  const url = `${API_BASE_URL}/organisation`;

  const response = yield request({
    method: 'put',
    data: formData,
    url,
  });
  if (response.success) {
    let notifyMessage = 'Institution Info saved Successfully!';
    if (updateAlias) {
      yield put(addInstitutionAliasSuccess(response.raw));
      notifyMessage = 'Institution aliases saved Successfully!';

    } else {
      yield put(addInstitutionSuccess(response.raw));

    }
    Notify(notifyMessage, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    const error = 'Failed to update institution information';
    yield put(addInstitutionFailed(error));
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* onAddInstitution() {
  yield takeLatest(IstitutionActionTypes.ADD_INSTITUTION, saveInstitution);
}
